import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Plane, Users } from 'lucide-react';

const PreArrivalCoaching: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#011E26] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Pre-Arrival Coaching</h1>
                    <p className="text-xl text-slate-300 max-w-2xl">
                        Transition smoothly into your new academic and cultural environment.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Plane className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Confident Departure</h2>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Starting your study abroad journey with confidence is key to success. Nex Overseas Pre-Arrival Coaching prepares students to transition smoothly into their new academic and cultural environment.
                    </p>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                        {['Travel', 'Accommodation', 'University Onboarding', 'Health & Safety'].map((area, i) => (
                            <div key={i} className="bg-blue-50 border border-blue-100 p-4 rounded text-center text-blue-900 font-semibold">
                                {area}
                            </div>
                        ))}
                    </div>

                    <p className="mb-6">
                        These areas give students the guidance they need to feel fully prepared and confident before departure.
                    </p>

                    <div className="bg-gray-50 border-l-4 border-[#009B8F] p-6 rounded-r-lg mb-8">
                        <div className="flex items-start gap-4">
                            <Users className="w-8 h-8 text-[#009B8F] mt-1" />
                            <div>
                                <h3 className="text-xl font-bold text-[#011E26] mb-2">Peer Mentorship</h3>
                                <p className="text-sm">
                                    To provide extra support, we connect students with peers who have previously studied abroad through Nex Overseas. These experienced mentors share insights, answer questions, and provide guidance, helping new students navigate their first steps with confidence and clarity.
                                </p>
                            </div>
                        </div>
                    </div>

                    <p className="mb-8">
                        With Nex Overseas, students benefit from structured guidance, personalised advice, and access to a supportive network, ensuring they start their international education journey well-prepared and ready to succeed.
                    </p>

                    <p className="mb-8 font-medium text-[#011E26]">
                        Get started today! Contact us to book your Pre-Arrival Coaching session and connect with expert advisors and alumni who can guide you every step of the way.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Book Your Session
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PreArrivalCoaching;
